import { Link } from '@box/blueprint-web';
import Button from 'box-ui-elements/es/components/button';
import { Flyout, Overlay } from 'box-ui-elements/es/components/flyout';
import React, { useEffect, useState } from 'react';
import AutosizeInput from 'react-input-autosize';
import CheckMark from '../../../../../../assets/icons/rich-text-editor-icons/checkmark';
import LinkIcon from '../../../../../../assets/icons/rich-text-editor-icons/link';
import PencilIcon from '../../../../../../assets/icons/rich-text-editor-icons/pencil';
import TrashIcon from '../../../../../../assets/icons/rich-text-editor-icons/trash';
import { KEYBOARD_CODE } from '../../../../../../constants';
import { getCompleteURL } from '../../../rte-utils';
import css from './set-link-flyout.module.scss';

type Props = {
  delLink: (arg1: undefined) => void;
  isActive: boolean;
  previousUrl: string;
  setLink: (arg1: string) => void;
};

const SetLinkFlyout = ({ isActive, previousUrl, setLink, delLink }: Props) => {
  const [url, setUrl] = useState('');
  const [editing, setEditing] = useState(false);
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  const handleUrlChange = (e: any) => setUrl(e.target.value);

  useEffect(() => {
    setUrl(previousUrl);
  }, [previousUrl]);

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  const handleConfirm = (e: any) => {
    e.stopPropagation();
    setLink(getCompleteURL(url));
    setEditing(false);
  };

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  const handleEdit = (e: any) => {
    e.stopPropagation();
    setEditing(true);
  };

  const handleDelete = () => {
    // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2554
    delLink();
    setEditing(false);
    setUrl('');
  };

  return (
    <Flyout className={css.setlinkFlyout} position="bottom-center">
      <Button
        className={isActive ? 'is-active' : ''}
        data-testid="toolbar-item-hyperlink"
        icon={<LinkIcon />}
      />
      <Overlay>
        <div className={css.urlOverlayContent}>
          {previousUrl && !editing ? (
            <>
              <div className={css.linkContainer}>
                <Link href={previousUrl} target="_blank">
                  {previousUrl}
                </Link>
              </div>

              <Button
                data-testid="edit-icon-button"
                icon={<PencilIcon />}
                onClick={handleEdit}
                type="button"
              />
              <Button
                data-testid="delete-icon-button"
                icon={<TrashIcon />}
                onClick={handleDelete}
                type="button"
              />
            </>
          ) : (
            <>
              {/*
               // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2786 */}
              <AutosizeInput
                minWidth={250}
                onChange={handleUrlChange}
                onKeyDown={ev => {
                  if (ev.keyCode === KEYBOARD_CODE.ENTER) {
                    handleConfirm(ev);
                  }
                }}
                placeholder="Enter URL"
                type="text"
                value={url}
                data-testid="edit-hyperlink-input"
              />
              <Button
                data-testid="check-icon-button"
                icon={<CheckMark />}
                onClick={handleConfirm}
                type="button"
              />
              <Button
                icon={<TrashIcon />}
                onClick={handleDelete}
                type="button"
              />
            </>
          )}
        </div>
      </Overlay>
    </Flyout>
  );
};

export default SetLinkFlyout;
